import * as React from "react"

function SvgError(props) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M10.986 10.986v-6.01H9.014v6.01h1.972zm0 4.038v-2.02H9.014v2.02h1.972zM10 0c1.827 0 3.518.457 5.072 1.37a9.478 9.478 0 013.558 3.558A9.834 9.834 0 0120 10a9.834 9.834 0 01-1.37 5.072 9.478 9.478 0 01-3.558 3.558A9.834 9.834 0 0110 20a9.834 9.834 0 01-5.072-1.37 9.657 9.657 0 01-3.558-3.582A9.791 9.791 0 010 10a9.79 9.79 0 011.37-5.048A9.842 9.842 0 014.952 1.37 9.79 9.79 0 0110 0z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgError
